<form [formGroup]="loginForm" (ngSubmit)="Login()" novalidate>
    <div class="login-panel">
        <div class="login-header">
            ĐĂNG NHẬP
        </div>
        <div class="login-body">
            <div class="p-grid">
                <div class="p-col-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="pi pi-user"></i></span>
                        <input type="text" pInputText placeholder="Tài khoản" name="username" formControlName="username" required autofocus>
                    </div>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="pi pi-key"></i></span>
                        <input type="password" pInputText placeholder="Mật khẩu" name="password" formControlName="password" required>
                    </div>
                </div>
            </div>
        </div>
        <div class="login-footer">
            <button pButton type="submit" label="Đăng nhập"><i class="pi pi-key"></i>&nbsp;</button>
            <button pButton type="button" style="margin-left: 0.25rem;" label="Xóa thông tin"
                class="p-button-secondary"><i class="pi pi-refresh"></i>&nbsp;</button>
        </div>
    </div>
</form>
<p-toast position="top-right"></p-toast>